import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimelineModalFilterService } from '../../../services/timeline-modal-filter.service';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';

@Component({
  selector: 'wilson-show-qualifed-staff-checkbox',
  imports: [CommonModule, FormsModule, TranslateModule, NzCheckboxModule],
  templateUrl: './show-qualifed-staff-checkbox.component.html',
  styleUrls: ['./show-qualifed-staff-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowQualifedStaffCheckboxComponent implements OnInit {
  private readonly cdRef = inject(ChangeDetectorRef);
  timelineModalFilterService = inject(TimelineModalFilterService);

  ngOnInit(): void {
    this.qualifiedStaffChanged(true);
  }

  qualifiedStaffChanged(showOnlyQualifiedStaff: boolean) {
    this.timelineModalFilterService.qualifiedStaffChanged(
      showOnlyQualifiedStaff,
    );
    this.cdRef.detectChanges();
  }
}
